// src/__internal__/shims/index.ts
export * from "./useDeferredValue.mjs";
export * from "./useSyncExternalStore.mjs";
export * from "./useTransition.mjs";
